import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {VideoConferenceService} from "../../video-conference.service";
import {ConfirmDialogComponent, DialogAction} from "inet-ui";
import {ChatMessageService} from "../../message.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {RoomChat} from "../../model/RoomChat";
import {MessageChat} from "../../model/MessageChat";
import {APP_CHAT} from "../../model/MessageConstants";
import {EnvelopBody, NotificationService} from "inet-core";
import {MessageChatHolder} from "../../model/MessageHolder";
import {FileListComponent, FileListItem} from "../../filelist/list/file-list.component";
import {OpenGraphService} from "../../open-graph";
import {GroupCallListComponent} from "../group-call-list/group-call-list.component";

declare let iNet: any;

@Component({
  selector: 'room-chat',
  templateUrl: './room-chat.component.html',
  styleUrls: ['./room-chat.component.scss']
})
export class RoomChatComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  @Input() roomName: any;
  @ViewChild('input') input!: ElementRef;
  @ViewChild(ConfirmDialogComponent) confirmDialog!: ConfirmDialogComponent;
  @ViewChild('messageBody') messageBody!: ElementRef;
  @ViewChild('listBody') listBody!: ElementRef;
  @ViewChild('fileList') fileList!: FileListComponent;
  @ViewChild(GroupCallListComponent) groupCallList!: GroupCallListComponent;
  videoPanelVisible: boolean = true;
  username = iNet.username;
  groupCallForm!: FormGroup;
  checkPhone = false;
  listRoom: RoomChat[] = [];
  files: any[] = [];
  flagInfoRoomChat = false;
  flagListMember = false;
  holders: MessageChatHolder[] = [];
  messageJoinCall: any = {};
  private linkRegex = /(https?:\/\/[^\s]+)/;
  flagHiddenListMember = true;
  flagHiddenAction = false;

  private _messageObserver: any;
  private __messageChat: any;

  constructor(
    private openGraphService: OpenGraphService,
    private videoService: VideoConferenceService,
    private messageService: ChatMessageService,
    private fb: FormBuilder,
    private notificationService: NotificationService,
  ) {
    this._messageObserver = this.messageService.messageReceived.subscribe((message: MessageChat) => {
      // console.log('dđ', message)
      if (message.message.message.alert) {
        let conferenceMessage = this.videoService.convertMessage(message.message.message.alert);
        if (conferenceMessage && conferenceMessage.conferenceID) {
          this.__messageChat = Object.assign({}, conferenceMessage.params);
          let action: string = this.__messageChat.action;
          let joins: string = message.message.message.joins;
          let members: Array<string> = joins.split(',');
          if (members && members.length > 0) {
            if (action === 'JOIN' || action === 'LEFT') {
              this.messageService.getGroupMessageList().subscribe(data => {
                for (let i = 0; i < data.items.length; i++) {
                  if (data.items[i].conferenceID == this.roomName.conferenceID) {
                    this.listRoom = data.items[i].members.map((v: any) => new RoomChat(v));
                    break;
                  }
                }
              });
            }
          }
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('hhh', this.roomName)
    const roomChange = changes.roomName.currentValue;
    // console.log(roomChange);
    if (roomChange.creator === this.username) {
      for (let lead of roomChange.members) {
        if (lead.username == roomChange.creator) {
          this.checkPhone = !lead.joined;
        }
      }
    } else {
      for (let lead of roomChange.members) {
        if (lead.username == roomChange.creator) {
          if (lead.joined) {
            for (let member of roomChange.members) {
              if (member.username == this.username) {
                this.checkPhone = !member.joined;
                break;
              }
            }
          } else {
            this.checkPhone = false;
          }
          break;
        }
      }
    }
    this.listRoom = this.roomName.members.map((v: any) => new RoomChat(v));
  }

  ngOnInit(): void {
    // this.joinRoom();
    // console.log('hhh', this.flagInfo)
  }

  ngAfterViewInit(): void {
    this.modalDelete();
  }

  private initGroupChatForm() {
    this.groupCallForm = this.fb.group({
      subject: ['', Validators.required],
      members: ['', Validators.required],
      conferenceID: ['']
    });
  }

  showNameMemberInGroup(data: any) {
    let username = '';
    for (let i = 0; i < data.length; i++) {
      if (username != '') {
        username = username + ', ' + '\n' + data[i].fullname;
      } else {
        username = data[i].fullname;
      }
    }
    return username;
  }

  get subject() {
    return this.groupCallForm.get('subject');
  }

  get members() {
    return this.groupCallForm.get('members');
  }

  get conferenceID() {
    return this.groupCallForm.get('conferenceID');
  }

  modalDelete() {
    const modalDeleteActions = [
      new DialogAction('Xóa', 'btn-danger', 'fa fa-check', () => {
        this.confirmDelete();
      }),
      new DialogAction('Hủy', 'btn-cancel', 'fa fa-remove', () => {
        this.confirmDialog.hide();
      })
    ];
    this.confirmDialog.setActions(modalDeleteActions);
  }

  ngOnDestroy(): void {
    this.disposeRoom();
  }

  joinRoom(roomName?: any) {
    this.flagHiddenAction = true;
    // console.log('joinRoom', roomName);
    // this.messageService.getGroupMessageList().subscribe(data => {
    //   console.log('data', data)
    // })
    this.videoPanelVisible = false;
    this.messageJoinCall['joined'] = false;
    if (!this.videoService.isExistMeet()) {
      this.messageJoinCall['joined'] = false;
      return;
    }
    const element = document.getElementById('meetRoom');
    if (element) {
      element.style.visibility = "visible";
      this.videoService.join(element, roomName, true, 350, (api: any, messages: any) => {
        api.addEventListener('readyToClose', () => {
          // console.log('readyToClose');
          this.videoService.dispose();
          element.style.visibility = "hidden";
          this.messageService.deleteGroupMessage(roomName).subscribe(data => {
            this.messageService.reloadGroupList();
            this.flagHiddenAction = false;
          })
        });
        api.addEventListener('videoConferenceJoined', () => {
          this.messageJoinCall = this.videoService.getMessageJoin();
          this.messageJoinCall['joined'] = true;
        });
        api.executeCommand('toggleShareScreen');

      });
    }
  }

  disposeRoom() {
    this.videoPanelVisible = true;
    this.videoService.dispose();
  }

  showModal() {
    this.confirmDialog.show();
  }

  chatAndShowListCall() {
    this.flagInfoRoomChat = !this.flagInfoRoomChat;
    this.flagListMember = false;
  }

  showListMemberRoom() {
    this.flagListMember = !this.flagListMember;
  }

  confirmDelete() {
    this.messageService.deleteGroupMessage(this.roomName.conferenceID).subscribe(data => {
      this.notificationService.showMessage('Xóa \"' + this.nameRoomShort(data.subject, 25) + '\" thành công', 'success', 'Delete Group Call');
      this.messageService.reloadGroupList();
      this.confirmDialog.hide();
    });
  }

  callAddMemberToGroup() {
    this.messageService.callToEditMessageForm(this.roomName);
  }

  // isJoined(member): boolean {
  //     return member.joined != null && member.joined == true
  //         && member.peerJid != null && member.peerJid.length > 0
  //         && member.sessionID != null && member.sessionID.length > 0;
  // }

  get canSend(): boolean {
    return this.files.length > 0 || this.message.length > 0;
  }

  get message(): string {
    return this.input && this.input.nativeElement.value.trim() || '';
  }

  get scrollTop(): number {
    return this.messageBody.nativeElement.scrollTop;
  }

  set scrollTop(scrollTop: number) {
    this.messageBody.nativeElement.scrollTop = scrollTop;
  }

  get scrollHeight(): number {
    return this.messageBody.nativeElement.scrollHeight;
  }

  get scrollBottom(): number {
    return this.scrollHeight - this.messageBody.nativeElement.scrollTop;
  }

  set scrollBottom(scrollBottom: number) {
    this.scrollTop = this.scrollHeight - scrollBottom;
  }

  // get scrollListTop(): number {
  //   return this.listBody.nativeElement.scrollTop;
  // }
  //
  // set scrollListTop(scrollTop: number) {
  //   this.listBody.nativeElement.scrollTop = scrollTop;
  // }

  // get scrollListHeight(): number {
  //   return this.listBody.nativeElement.scrollHeight;
  // }
  //
  // get scrollListBottom(): number {
  //   return this.scrollListHeight - this.listBody.nativeElement.scrollTop;
  // }
  //
  // set scrollListBottom(scrollBottom: number) {
  //   this.scrollTop = this.scrollListHeight - scrollBottom;
  // }

  encodeBase64(str: string) {
    return window.btoa(unescape(encodeURIComponent(str)));
  }

  decodeBase64(str: string) {
    return decodeURIComponent(escape(window.atob(str)));
  }

  viewAttachment(e: { file: FileListItem }) {
    window.open(e.file.url, '_blank');
  }

  private _focus() {
    this.flagInfoRoomChat = true
    // this.flagInfo = true
    this.input.nativeElement.focus();
  }

  sendMessage() {
    let value = this.message.trim();
    this.sendMessageSocket(value);
  }

  sendMessageSocket(value: string) {
    // console.log('dhdhhd', value)
    if (value || this.files.length > 0) {
      if (this.files.length > 0) {
        if (value == '') {
          value = this.files[0].name;
        }
        this._sendPush(value);
      } else {
        this._sendSocket(value);
      }
      this._clearInput();
    }
  }

  private _sendSocket(value: string) {
    if (this.username) {
      const envelop = this.messageService.buildEnvelop(this.username, value);
      this.messageService.sendEnvelop(envelop);
      this._sendSuccess(new MessageChat(envelop.body));
    }
  }

  private _sendPush(value: string) {
    var params: any = {
      content: value,
      alert: value,
      application: APP_CHAT,
      alias: this.username,
    };
    this.files.forEach(function (file, i) {
      params['file-' + i] = file;
    });
    this.messageService.pushMessage(params, (message: EnvelopBody) => {
      if (message) {
        this._sendSuccess(new MessageChat(message));
      }
    });
  }

  private _sendSuccess(message: MessageChat) {
    this._addMessages([this.convertMessages(message)], true);
    if (this.username) {
      this.messageService.updateLastMessage(this.username, message.message);
      this.messageService.resetUnreadMessage(this.username);
    }

    this._scrollToBottom();
  }

  private _clearInput() {
    this.files.length = 0;
    this.files = [];
    this.input.nativeElement.value = '';
    this._focus();
    this.fileList.removeAllFile(this.files);
  }

  private _scrollToBottom() {
    setTimeout(() => {
      this.scrollTop = this.scrollHeight;
    }, 100);
  }

  private _addMessages(messagesArr: MessageChat[], insertLast: boolean = false) {
    let messages = this.convertArrayMessage(JSON.stringify(messagesArr));
    messages.sort((a: any, b: any) => b.date.getTime() - a.date.getTime());
    messages.forEach((message: any) => {
      let holder;
      for (let i = 0; i < this.holders.length; i++) {
        if (this.holders[i].isSameDate(message.date)) {
          holder = this.holders[i];
          break;
        }
      }
      if (!holder) {
        holder = new MessageChatHolder(message.date);
        if (insertLast) {
          this.holders.push(holder);
        } else {
          this.holders.unshift(holder);
        }
      }
      if (insertLast) {
        holder.messages.push(message);
      } else {
        holder.messages.unshift(message);
      }
    });
  }

  private convertArrayMessage(arrMessage: any) {
    let arr = JSON.parse(arrMessage);
    arr.forEach((ele: any) => {
      ele = this.convertMessages(ele);
      ele.date = new Date(ele.date);
      return ele;
    });
    return arr;
  }

  private convertMessages(messages: any) {
    if (!iNet.isEmpty(messages)) {
      let __mes = this.messageService.revertMessage(messages.displayText) || '';
      let __mesDisplay = this.messageService.revertMessageDisplay(messages.displayText) || '';
      let typeMessages = __mes.split(":");
      if (typeMessages.length >= 2) {
        if (typeMessages[0] === 'uri_message' && typeMessages[1] === 'video_conference') {
          let __messageChat = JSON.parse(this.decodeBase64(typeMessages[2])) || {};
          if (messages.message.sender === this.username) {
            if (__messageChat.action === 'END') {
              if (messages.message.message.joins.split(',').length === 1) {
                messages.displayText = this.messageMissCall();
                return messages;
              } else {
                messages.displayText = this.messageJoinedCall(messages.message.message.duration);
                return messages;
              }
            }
            if (__messageChat.action === 'LEFT' && messages.message.message.joins.split(',')[0] === messages.message.sender) {
              if (messages.message.message.joins.split(',').length === 1) {
                messages.displayText = this.messageMissCall();
                return messages;
              } else {
                messages.displayText = this.messageJoinedCall(messages.message.message.duration);
                return messages;
              }
            } else {
              return messages;
            }

          } else {
            if (__messageChat.action === 'END') {
              if (messages.message.message.joins.split(',').length === 1) {
                messages.displayText = this.messageMissCall();
                return messages;
              } else {
                messages.displayText = this.messageJoinedCallTo(messages.message.message.duration);
                return messages;
              }
            } else {
              if (this.messageJoinCall['joined']) {
                messages.displayText = this.messageJoinedCallTo(messages.message.message.duration);
                return messages;
              } else {
                messages.displayText = this.messageMissCall();
                return messages;
              }
            }

          }
        } else {
          let links = this.linkRegex.exec(__mes);
          if (links && links.length > 0) {
            links.forEach(link => {
              if (this.openGraphService.isLink(link)) {
                this.openGraphService.loadPreviewLink(link, (grapData: any) => {
                  try {
                    messages['_openGraph'] = this.convertLinks(grapData, link);
                    messages.displayText = messages.displayText;
                    return messages;
                  } catch (e) {

                  }
                });
              }
            })
          } else {
            return messages;
          }

          // if (typeMessages[0] === 'uri_message' && typeMessages[1] === 'link_preview') {
          //     let __messageLink = JSON.parse(this.decodeBase64(typeMessages[2])) || {};
          //     messages['_openGraph'] = __messageLink;
          //     messages.displayText = __mesDisplay;
          //     return messages;
          // } else {
          return messages;
          // }
        }
      } else {
        return messages;
      }
    }
  }

  convertLinks(data: any, link: string) {
    let param: any = {};
    param['title'] = data['title'];
    param['image'] = data['image'];
    param['description'] = data['description'];
    param['url'] = link;
    let __host = new URL(link);
    param['finalUrl'] = __host.host.toUpperCase();
    return param;
  }

  messageMissCall() {
    // $('.message-chat__miss').on('click',()=>{
    //     console.log('click')
    //     this.joinRoom(true);
    // })
    return '<div class="contact d-flex my-1" role="button" style="">\n' +
      '    <i class="message-chat__miss fa fa-phone ml-0"></i>\n' +
      '    <div class="contact-content pl-2">\n' +
      '        <div class="contact-name mb-1">Cuộc gọi bị nhỡ</div>\n' +
      '        <div class="contact-detail">Gọi lại</div>\n' +
      '    </div>\n' +
      '</div>'
  }

  messageJoinedCall(duration: any) {
    return '<div class="contact d-flex my-1" role="button" style="">\n' +
      '    <i class="message-chat__action fa fa-phone ml-0"></i>\n' +
      '    <div class="contact-content pl-2">\n' +
      '        <div class="contact-name mb-1">Cuộc gọi thoại đến</div>\n' +
      '        <div class="contact-detail">' + duration + ' giây' + '</div>\n' +
      '    </div>\n' +
      '</div>'
  }

  messageJoinedCallTo(duration: any) {
    return '<div class="contact d-flex my-1" role="button" style="">\n' +
      '    <i class="message-chat__action fa fa-phone ml-0"></i>\n' +
      '    <div class="contact-content pl-2">\n' +
      '        <div class="contact-name mb-1">Cuộc gọi thoại đi</div>\n' +
      '        <div class="contact-detail">' + duration + ' giây' + '</div>\n' +
      '    </div>\n' +
      '</div>'
  }

  nameRoomShort(data: string, number: number) {
    // console.log('test', data.length)
    let result = '';
    if (data.length > number) {
      result = data.slice(0, number);
      return result + '...';
    } else {
      return data;
    }
  }

  checkLeader(data: any) {
    return data.creator
  }

  getUserCodeMember(data: any) {
    return this.checkLeader(this.roomName) == data.username;
  }

  hiddenMemberGroup() {
    this.flagHiddenListMember = !this.flagHiddenListMember;
  }

  hiddenAction() {
    this.flagHiddenAction = true;
  }
}
